import { IDate, IObjectTimecardDocument, IPayrollStatusDocument } from "../../../../models"

export interface ITimecardFullData {
    Pending: boolean
    Timecard: IObjectTimecardDocument
    PriorPeriodTimecards: IObjectTimecardDocument[]
    PayrollStatus: IPayrollStatusDocument[]
    DailyNoteDates: IDate[]
    SuspensePunchData: ISuspensePunchData
    JobStatusData: IJobStatusData[]
    CommentData: ICommentData[]
}

export interface ISuspensePunchData {
    ReviewSuspensePunchData: ISuspenseTimeData[]
    ReviewSuspenseUpdateTimeData: ISuspenseTimeData[]
}

export interface ISuspenseTimeData {
    Id: string
    DateTime: IDate
    DateTimeLocal: IDate
}

export interface IJobStatusData {
    Id: string
    JobStatusType: EJobStatusType
}

export enum EJobStatusType {
    Activated,
    Inactived,
    Deleted
}

export interface ICommentData {
    Id: string
    Comment: string
}